import Immutable from 'immutable';
import {
  GET_SERVICE_MERGE,
  CLEAR_SERVICE_MERGE,
  FLAG_SERVICE_MERGE_ACTIVITY,
  FLAG_GETTING_SOURCE_ITINERARY_SEATMAP,
  GET_SOURCE_ITINERARY_SEATMAP,
  CLEAR_SOURCE_ITINERARY_SEATMAP,
  FLAG_GETTING_DESTINATION_ITINERARY_SEATMAP,
  GET_DESTINATION_ITINERARY_SEATMAP,
  CLEAR_DESTINATION_ITINERARY_SEATMAP,
  GET_SOURCE_ITINERARY_PASSENGER_LIST,
  CLEAR_SOURCE_ITINERARY_PASSENGER_LIST,
  GET_DESTINATION_ITINERARY_PASSENGER_LIST,
  CLEAR_DESTINATION_ITINERARY_PASSENGER_LIST,
  FLAG_GETTING_SERVICE_MERGES,
  GET_SERVICE_MERGES,
  CLEAR_SERVICE_MERGES,
} from '../../../actions/types/itinerary/ServiceMerge';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  sourceItinerary: Immutable.Map({
    seatMap: Immutable.Map(),
    passengerList: Immutable.Set(),
    loading: false,
  }),
  destinationItinerary: Immutable.Map({
    seatMap: Immutable.Map(),
    passengerList: Immutable.Set(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_SERVICE_MERGES:
      return state.setIn(['all', 'loading'], payload);
    case GET_SERVICE_MERGES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_SERVICE_MERGES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_SERVICE_MERGE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_SERVICE_MERGE:
      return state.setIn(
        ['current', 'content'],
        INITIAL_STATE.getIn(['current', 'content']),
      );
    case FLAG_SERVICE_MERGE_ACTIVITY:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case FLAG_GETTING_SOURCE_ITINERARY_SEATMAP:
      return state.setIn(['sourceItinerary', 'loading'], payload);
    case GET_SOURCE_ITINERARY_SEATMAP:
      return state.setIn(
        ['sourceItinerary', 'seatMap'],
        Immutable.Map(payload),
      );
    case CLEAR_SOURCE_ITINERARY_SEATMAP:
      return state.setIn(
        ['sourceItinerary', 'seatMap'],
        INITIAL_STATE.getIn(['sourceItinerary', 'seatMap']),
      );
    case GET_SOURCE_ITINERARY_PASSENGER_LIST:
      return state.setIn(
        ['sourceItinerary', 'passengerList'],
        Immutable.Set(payload),
      );
    case CLEAR_SOURCE_ITINERARY_PASSENGER_LIST:
      return state.setIn(
        ['sourceItinerary', 'passengerList'],
        INITIAL_STATE.getIn(['sourceItinerary', 'passengerList']),
      );
    case FLAG_GETTING_DESTINATION_ITINERARY_SEATMAP:
      return state.setIn(['destinationItinerary', 'loading'], payload);
    case GET_DESTINATION_ITINERARY_SEATMAP:
      return state.setIn(
        ['destinationItinerary', 'seatMap'],
        Immutable.Map(payload),
      );
    case CLEAR_DESTINATION_ITINERARY_SEATMAP:
      return state.setIn(
        ['destinationItinerary', 'seatMap'],
        INITIAL_STATE.getIn(['destinationItinerary', 'seatMap']),
      );
    case GET_DESTINATION_ITINERARY_PASSENGER_LIST:
      return state.setIn(
        ['destinationItinerary', 'passengerList'],
        Immutable.Set(payload),
      );
    case CLEAR_DESTINATION_ITINERARY_PASSENGER_LIST:
      return state.setIn(
        ['destinationItinerary', 'passengerList'],
        INITIAL_STATE.getIn(['destinationItinerary', 'passengerList']),
      );
    default:
      return state;
  }
};
